import { Pet } from "../../core/pet";
import { Resistance, type AbnormalResistance } from "../../core/pet";
import { AbilityValue } from "../../core/abval";
import * as type from "../../core/type";
import * as skill from "../skill/厄尔塞拉";
import { Soulmark } from "../../core/soulmark";

export class 厄尔塞拉 extends Pet {
    /**
     *
     * @param ablis 能力值
     * @param resis 伤害抗性
     * @param abnormalResistance 异常抗性，默认无
     */
    constructor(ablis: AbilityValue, resis: Resistance, abnormalResistance: ReadonlyArray<Readonly<AbnormalResistance>> = []) {
        super(421, "厄尔塞拉", type.光, ablis);
        this.抗性 = resis;
        this.异常抗性 = abnormalResistance;
        this.魂印 = new Soulmark([
            "厄尔塞拉身披七色光羽，一周七天每天在七色光芒中轮回。厄尔塞拉登场时，激活全部七色光羽效果。厄尔塞拉存活时，己方所有其他精灵都获得当天相应的七色光羽效果。",
            "七色光羽效果说明：",
            "红光（周一）：攻击技能有60%的几率令对手失明，连续使用攻击技能时每次几率增加10%。",
            "橙光（周二）：回合结束时若体力低于1/2，则恢复自身最大体力的1/3。",
            "黄光（周三）：登场后4回合内免疫异常状态，免疫能力下降",
            "绿光（周四）：所有技能先制+1，先出手时对手无法通过技能恢复体力",
            "青光（周五）：受到的攻击伤害减少30%，受到的固定伤害和百分比伤害减少15%。",
            "蓝光（周六）：对手使用属性技能时消耗的pp为正常状态下的2倍，并且有40%的几率失效。",
            "紫光（周日）：致命一击几率提升1/8，未触发致命一击则附加自身最大体力20%的固定伤害。",
        ]);
        this.技能组 = [
            skill.幻化光芒,
            skill.时空裂痕,
            skill.光芒附体,
            skill.奇幻光芒,
            skill.七彩光芒,
        ];
    }
}
